import OrderMatchingItem from './OrderMatchingItem.component';

export default OrderMatchingItem;